const appConfig = () => {
  return {
    nodeApiLink: '/',
    oracleApiLink: 'https://erg-usd-ergo-oracle.emurgo.io',
  };
};

export default {
  ...appConfig(),
};
